<template>
  <div>
    <div class="row mt-4 box-users">
      <div class="col-md-6 border-right mb-3">
        <h5>Usuarios de la empresa</h5>
        <div class="d-flex align-items-center justify-content-end">
          <b-form-input
            v-model="search"
            class="d-inline-block mr-1"
            placeholder="Filtrar..."
            data-cy="search-user"
          />
        </div>
      </div>
      <div class="col-md-6 border-right mb-3">
        <h5>Usuarios que recibirán los perfiles</h5>
      </div>
      <div class="col-md-6 border-right">
        <vs-list class="box-users">
          <div
            v-for="user in filteredUsers"
            :key="user.id"
          >
            <vs-list-item
              :class="{ exists: isUserInGroup(user) }"
              :title="user.nombre"
              :subtitle="user.correo"
            >
              <vs-button
                color="warning"
                v-if="!isUserInGroup(user)"
                size="small"
                type="border"
                @click="addUser(user)"
                data-cy="add-permission"
              >
                Agregar
              </vs-button>
            </vs-list-item>
          </div>
        </vs-list>
      </div>
      <div class="col-md-6">
        <vs-list class="box-users">
          <div
            v-for="user in selectedUsers"
            :key="user.id"
            data-cy="remove-permission"
          >
            <vs-list-item
              :title="user.nombre"
              :subtitle="user.correo"
            >
              <vs-button
                color="danger"
                size="small"
                type="border"
                icon="highlight_off"
                @click="removeUser(user)"
                data-cy="remove-permission"
              />
            </vs-list-item>
          </div>
        </vs-list>
      </div>
    </div>
    <div class="mt-4 p-3 border rounded bg-light">
      <h6 class="mb-3">
        <i class="feather icon-settings mr-2"></i>
        Configuración de copia
      </h6>
      <b-form-radio-group
        v-model="reemplazar"
        :options="reemplazarOptions"
        name="reemplazar-perfiles"
        stacked
      />
    </div>
    <div class="mt-4 text-right">
      <b-button
        variant="primary"
        @click="saveChanges"
      >
        Guardar cambios
      </b-button>
    </div>
  </div>
</template>
<script>

import { mapActions, mapGetters } from 'vuex';

export default {
  mixins: [],
  props: {
    user: {
      type: Object,
      required: true
    },
    usersGeneral: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      search: '',
      selectedUsers: [],
      reemplazar: 'N',
      reemplazarOptions: [
        {
          text: 'Mantener perfiles existentes y agregar los nuevos',
          value: 'N',
          html: '<strong>Mantener perfiles existentes</strong><br><small class="text-muted">Los usuarios destino conservarán sus perfiles actuales y se agregarán los nuevos</small>'
        },
        {
          text: 'Reemplazar todos los perfiles',
          value: 'Y',
          html: '<strong>Reemplazar todos los perfiles</strong><br><small class="text-muted">Se eliminarán los perfiles actuales y se copiarán solo los del usuario de origen</small>'
        }
      ]
    };
  },
  computed: {
    ...mapGetters('Empresas', [
      'company',
      'usersByGroup',
      'usersCompanyAssign'
    ]),
    ...mapGetters('Modals', [
      'modalName'
    ]),
    filteredUsers() {
      if (this.search !== '') {
        return this.usersGeneral.filter(
          (user) => user.nombre.toLowerCase().indexOf(this.search.toLowerCase()) > -1
        );
      }
      return this.usersGeneral;
    }
  },
  methods: {
    ...mapActions('Modals', [
      'closeModal'
    ]),
    ...mapActions('Usuario', [
      'copyUserProfiles'
    ]),
    isUserInGroup(user) {
      return (this.selectedUsers || []).find((userGroup) => userGroup.id === user.id);
    },
    removeUser(user) {
      this.selectedUsers = this.selectedUsers.filter((userSelected) => userSelected.id !== user.id);
    },
    addUser(user) {
      this.selectedUsers.push(user);
    },
    async saveChanges() {
      if (!this.selectedUsers.length) {
        this.$bvToast.toast(
          'No has agregado ningún usuario para recibir perfiles',
          {
            title: '¡Oye!',
            variant: 'warning',
            pauseOnHover: true,
            solid: true,
            autoHideDelay: 4000
          }
        );
        return;
      }
      const targetUsersIds = this.selectedUsers.map((userMap) => userMap.id);
      await this.copyUserProfiles(
        {
          userId: this.user.id,
          companyId: this.company.id,
          targetUsersIds,
          reemplazar: this.reemplazar
        }
      );
      this.$emit('close-action');
      setTimeout(() => {
        this.$bvToast.toast(
          'Se ha realizado la acción correctamente',
          {
            title: 'Genial',
            variant: 'primary',
            pauseOnHover: true,
            solid: true,
            autoHideDelay: 4000
          }
        );
      }, 300);
    }
  }
};
</script>
<style scoped>

.box-users {
  height: 500px;
  overflow-y: auto;
}

.con-vs-popup .vs-popup {
  width: 70% !important;
}

.exists {
  color: #671e85;
  background: #671e852b;
  border-radius: 4px;
  margin-top: 2px;
}

.bg-light {
  background-color: #f8f9fa !important;
}

.border {
  border: 1px solid #dee2e6 !important;
}

.rounded {
  border-radius: 0.25rem !important;
}
</style>
